import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'underscoreToSpace' })
export class UnderscoreToSpacePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';
    return value.replace(/_/g, ' ');
  }
}